import {Input, Button} from 'react-bootstrap'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    chooseIfSendNotificationWhenInterventionAccepted,
    updateOtherRecipientInInterventionAcceptedNotification
} from '../actions'

class SendInterventionInfoToAssignee extends Component {
    _decideIfSendNotif = () => {
        const {acceptInterventionCmd, dispatch} = this.props
        const onChange = (event) => {
            const choice = event.target.value
            dispatch(chooseIfSendNotificationWhenInterventionAccepted({
                accepted: true,
                sendItOrNot: choice,
            }))
        }

        const {sendItOrNot} = acceptInterventionCmd
        return {value: sendItOrNot || 'headerChoice', onChange}
    }

    _calculChoices = () => {
        const {assignee, acceptInterventionCmd} = this.props
        const {sendItOrNot} = acceptInterventionCmd

        const emails = assignee && assignee.emails
        const headChoice = [{v: 'headerChoice', label: 'choisir d\'envoyer une notification ...'}]
        const notSendChoice = [{v: 'doNotSendNotif', label: 'Ne pas envoyer de notification'}]
        const mails = emails.map((m) => ({v: m, label: m}))

        return sendItOrNot ? notSendChoice.concat(mails) : headChoice.concat(notSendChoice).concat(mails)
    }

    updateOtherRecipient = (i) => (e) => {
        const {acceptInterventionCmd, dispatch} = this.props
        const {otherEmails} = acceptInterventionCmd
        otherEmails[i] = e.target.value
        dispatch(updateOtherRecipientInInterventionAcceptedNotification({otherEmails: [...otherEmails]}))
    }

    addOtherRecipient = () => {
        const {acceptInterventionCmd, dispatch} = this.props
        const {otherEmails} = acceptInterventionCmd
        if (this.lastRecipientFulfilled()) {
            dispatch(updateOtherRecipientInInterventionAcceptedNotification({otherEmails : [ ...otherEmails, undefined]}))
        }
    }

    removeOtherRecipient = (i) => () => {
        const {acceptInterventionCmd, dispatch} = this.props
        const {otherEmails} = acceptInterventionCmd
        const newOtherEmails = [...otherEmails.slice(0, i), ...otherEmails.slice(i+1)]

        dispatch(updateOtherRecipientInInterventionAcceptedNotification(({otherEmails : newOtherEmails})))
    }

    lastRecipientFulfilled() {
        const {acceptInterventionCmd} = this.props
        const {otherEmails} = acceptInterventionCmd

        return Boolean(otherEmails.length === 0 || otherEmails.slice(-1)[0])
    }

    renderOtherRecipients = () => {
        const {acceptInterventionCmd} = this.props
        const {sendItOrNot, otherEmails} = acceptInterventionCmd

        return (sendItOrNot && sendItOrNot !== 'doNotSendNotif' && <div>
            <Button
                bsSize='small'
                bsStyle='link'
                onClick={this.addOtherRecipient}
                disabled={!this.lastRecipientFulfilled()}>
                Ajouter un autre destinataire
            </Button>
            {otherEmails.map ( (or, i) => {
                return (<div key={i}>
                    <Button
                        bsSize='small'
                        bsStyle='link'
                        onClick={this.removeOtherRecipient(i)}>
                        Enlever ce destinataire
                    </Button>
                    <Input type="text" value={or} onChange={this.updateOtherRecipient(i)}/>
                </div>)
            })}
        </div>)
    }

    render() {
        const {assignee} = this.props
        const link = assignee && (assignee.assigneeType === 'ProviderContact' && `/providercontacts/${assignee.uid}` || `/providers/${assignee.uid}`)

        const hasEmail = (assignee && <div>
            <div>Merci de confirmer <b><a href={link} target={'_blank'}>l'email du fournisseur</a></b> afin de lui envoyer une notification</div>

            <br/>
            <Input
                labelClassName='col-sm-3'
                wrapperClassName='col-sm-9'
                type='select'
                label=''
                {...this._decideIfSendNotif()}>
                {this._calculChoices().map((choice) => (
                    <option
                        key={choice.v}
                        value={choice.v}>
                        {choice.label}
                    </option>
                ))}
            </Input>
            <br/>
            {this.renderOtherRecipients()}
        </div>)

        return hasEmail || (<div/>)
    }
}

SendInterventionInfoToAssignee = connect(({ticket}) => {
    const {acceptInterventionCmd} = ticket
    return {acceptInterventionCmd}
})(SendInterventionInfoToAssignee)
export default SendInterventionInfoToAssignee


// WEBPACK FOOTER //
// ./lib/ticket/components/SendInterventionInfoToAssignee.js